module.exports = __webpack_public_path__ + "img/theme1.d7db034a.png";